<template>
  <div class="md:h-screen">
    <div class="h-full w-full font-bold flex justify-center items-center">
      500 サーバーエラー<br />
      復旧するまでしばらくお待ちください。
    </div>
  </div>
</template>
